module.exports = __webpack_public_path__ + "static/media/foursquare.e7dda514.png";